import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  state: {
    comments: null,
    notifications: null,
    entityId: null,
    isLoadedComments: false,
    notificationsCount: 0,
    isFromNotif: false,
    notifLink: null,
    isLoadedEntityId: false
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/comments/index.js